import { getProductTypeFromRouteSlug, normalizeColorRoute } from './colorRoute'

export type ProductViewItemTracking = {
  itemId: string
  itemName: string
  price: number
  currency: 'EUR'
  itemBrand: 'Kendrick Paris'
  itemCategory: string
  color: string
}

const productTrackingCatalog: Record<string, { itemName: string, price: number, itemCategory: string }> = {
  'ankle-boots': {
    itemName: 'ALIGN 110 Ankle Boot',
    price: 680,
    itemCategory: 'ankle-boots'
  },
  boots: {
    itemName: 'AXIS 110 Boot',
    price: 980,
    itemCategory: 'boots'
  },
  pumps: {
    itemName: 'EDGE 110 Pump',
    price: 450,
    itemCategory: 'pumps'
  },
  sandals: {
    itemName: 'POISE 110 Sandal',
    price: 490,
    itemCategory: 'sandals'
  }
}

const productRoutePattern = /^\/(?:fr\/)?(boots|ankle-boots|pumps|sandals|bottines|bottes|escarpins|sandales)\/([^/?#]+)\/?$/

export function resolveProductViewItemTracking(path: string): ProductViewItemTracking | null {
  const pathWithoutQuery = path.split('?')[0] || ''
  const pathWithoutHash = pathWithoutQuery.split('#')[0] || ''
  const normalizedPath = pathWithoutHash.replace(/\/+$/, '') || '/'
  const match = normalizedPath.match(productRoutePattern)
  if (!match) return null

  const productType = getProductTypeFromRouteSlug(match[1] || '') as keyof typeof productTrackingCatalog | undefined
  const rawColor = match[2]
  if (!productType || !rawColor) return null

  const color = normalizeColorRoute(rawColor)
  const product = productTrackingCatalog[productType]
  if (!product || !color) return null

  return {
    itemId: `${productType}-${color}`,
    itemName: product.itemName,
    price: product.price,
    currency: 'EUR',
    itemBrand: 'Kendrick Paris',
    itemCategory: product.itemCategory,
    color
  }
}
